import {DataFrameColumnDef, DataFrameSpec} from 'data-frames/DataFrameTypes';

/**
 * Find a column definition by name in a data frame spec.
 *
 * @param dataFrameSpec The data frame spec to search
 * @param columnSystemName The internal system name of the column
 * @return The matching column definition, or undefined if there is no column with the name
 */
export default function findColumn(
  dataFrameSpec: Pick<DataFrameSpec, 'columns'>,
  columnSystemName: string
): DataFrameColumnDef | undefined {
  return dataFrameSpec.columns.find((columnDef) => columnDef.systemName === columnSystemName);
}

/**
 * Return the first column definition that matches the given display name if any exist; otherwise, return undefined
 */
export function findColumnByDisplayName(
  dataFrameSpec: Pick<DataFrameSpec, 'columns'>,
  columnDisplayName: string
): DataFrameColumnDef | undefined {
  return dataFrameSpec.columns.find((columnDef) => columnDef.displayName === columnDisplayName);
}
